export default __webpack_public_path__ + "static/media/logo.db9d696b.svg";